/** These GET callers own an explicit absent/unavailable state in their feature UI. */
export function isUnavailableOptionalRead(status: number, url: string, method: string): boolean {
  if (method !== 'GET') return false;
  const path = url.replace(/^https?:\/\/[^/]+/, '').split(/[?#]/, 1)[0];
  if (path === '/api/v1/risk/metrics/history') return status === 404 || status === 501;
  if (status !== 404) return false;
  return [
    '/api/v1/risk/profiles/active',
    '/api/v1/risk/var/history',
    '/api/v1/risk/metrics/drawdown/history',
    '/api/v1/risk/metrics/compare',
  ].includes(path) || /^\/api\/v1\/regulatory\/calendar\/\d{4}$/.test(path);
}
